<template>
  <QCard
    flat
    :bordered="false"
  >
    <!-- Recommended Tag -->
    <div
      v-if="recommended"
      class="recommended-badge tw-text-sm tw-px-3 tw-py-1 tw-rounded tw-mb-2"
    >
      {{ $t('global.recommended') }}
    </div>

    <QCardSection
      :horizontal="horizontal"
      class="tw-p-0"
    >
      <MediaImageLazyLoad
        :src="`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`"
        :placeholder-src="`https://img.youtube.com/vi/${videoId}/default.jpg`"
        :alt="title"
        is-show-icon-play
        :is-main-card="isMainCard"
        :ratio="16/9"
        custom-class="tw-rounded-xl"
        :class="[
          horizontal
            ? 'tw-w-[160px] tw-aspect-video lg:tw-w-[255px]'
            : 'tw-w-full tw-aspect-video',
          'tw-rounded-xl tw-overflow-hidden tw-cursor-pointer'
        ]"
        @click="() => showVideoModal = true"
      />
      <MediaVideoModal
        v-model="showVideoModal"
        :youtube-url="props.youtubeUrl"
        video-width="tw-w-full"
        video-height="tw-aspect-video"
        custom-video-player="tw-rounded-xl"
        :container-style="{ width: '90vw', maxWidth: '1024px' }"
      />
      <QCardSection
        :class="[
          horizontal ? 'tw-flex-1 tw-pl-4 lg:tw-pt-4 tw-pt-0' : 'tw-w-full',
          {
            'tw-pt-4': !horizontal
          },
        ]"
        class="tw-flex tw-flex-col tw-px-0 tw-pb-0 tw-cursor-pointer"
        @click="() => showVideoModal = true"
      >
        <!-- Video Category -->
        <div class="tw-text-mb-body-tiny lg:tw-text-dt-body-small tw-text-secondary tw-truncate tw-mb-1">
          {{ videoCategory.title }}
        </div>
        <!-- Video Title -->
        <component
          :is="titleTag"
          class="tw-text-mb-title-5 lg:tw-text-dt-title-5 tw-text-black tw-line-clamp-2 tw-mb-1"
          :class="customVideoTitleClass"
        >
          {{ title }}
        </component>
        <!-- Video Description -->
        <p
          :class="isMainCard ? 'tw-line-clamp-2' : 'tw-hidden lg:tw-line-clamp-2'"
          class="tw-text-mb-body-small lg:tw-text-dt-body-small tw-text-dark-gray"
        >
          {{ description }}
        </p>
      </QCardSection>
    </QCardSection>
  </QCard>
</template>

<script setup lang="ts">
const props = defineProps({
  youtubeUrl: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  videoCategory: {
    type: Object as () => Category,
    required: true,
  },
  horizontal: {
    type: Boolean,
    default: false,
  },
  recommended: {
    type: Boolean,
    default: false,
  },
  isMainCard: {
    type: Boolean,
    default: false,
  },
  titleTag: {
    type: String,
    default: 'h3',
  },
  customVideoTitleClass: {
    type: String,
    default: ''
  },
  videoCategoryClass: {
    type: String,
    default: ''
  }
})

// Computed Values
const { getYoutubeIdFromUrl } = useYoutube()
const videoId = computed(() => getYoutubeIdFromUrl(props.youtubeUrl))

// State
const showVideoModal = ref(false)
</script>

<style scoped>
.recommended-badge {
  background: var(--theme-color-secondary);
  color: var(--theme-color-inverted-secondary);
}
</style>
